import { FlexWorkersForProjectFilters } from 'shared/components/flex-workers-for-work-table/flex-workers-for-work.types';
import { FlexWorkerProfileData } from '@types';
import { GetFlexWorkersForShiftPlanningFilterProps } from 'shared/components/shift-detail-modal/query-hooks/hq/use-get-flex-workers-for-shift-planning.types';
import { OgpApiService } from './ogp-api-service';
import { GetAllFlexWorkersResponse } from './flex-worker-service.types';

class FlexWorkerService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public async getFlexWorkersWhoWorkedForCompany(props: GetFlexWorkersForShiftPlanningFilterProps) {
    return await this.ogpApiService.get<GetAllFlexWorkersResponse>({
      path: `flex-workers/worked-for-company/${props.shiftId}`,
      params: { page: props.page, pageSize: props.pageSize, ...props.filters },
    });
  }

  public async getAllFlexWorkersForProject(props: {
    projectId: string;
    page: number;
    pageSize: number;
    filters?: FlexWorkersForProjectFilters;
  }) {
    return await this.ogpApiService.get<GetAllFlexWorkersResponse>({
      path: `flex-workers/in-relation-to-project/${props.projectId}`,
      params: { page: props.page, pageSize: props.pageSize, ...props.filters },
    });
  }

  public async getFlexWorkersWhoWorkedForCompanyForProject(props: {
    projectId: string;
    page: number;
    pageSize: number;
    filters?: FlexWorkersForProjectFilters;
  }) {
    return await this.ogpApiService.get<GetAllFlexWorkersResponse>({
      path: `flex-workers/worked-for-company-for-project/${props.projectId}`,
      params: { page: props.page, pageSize: props.pageSize, ...props.filters },
    });
  }

  /**
   * Get the FlexWorker Profile cover for a FlexWorker
   */
  public getFlexWorkerProfileCover = async (flexWorkerId: string) => {
    const response = await this.ogpApiService.get<FlexWorkerProfileData>({
      path: `flex-workers/profile-cover/${flexWorkerId}`,
    });
    return response;
  };
}

export { FlexWorkerService };
